<template>
    <div>
        <div class="form-group">
            <label>Organisation ID</label>
            <input type="text" class="form-control" v-model="data.id">
        </div>
    </div>
</template>

<script>
export default {
    components: {},
    props: [
        'data',
    ],
    data() {
        return {};
    },
};
</script>